import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { SupplierOption } from '../../types/purchasing';

interface SupplierPickerProps {
  suppliers: SupplierOption[];
  value: number | null;
  onChange: (supplierId: number | null) => void;
  disabled?: boolean;
}

const SupplierPicker: React.FC<SupplierPickerProps> = ({
  suppliers,
  value,
  onChange,
  disabled = false,
}) => {
  const selected =
    suppliers.find((supplier) => supplier.supplierId === value) || null;

  return (
    <Autocomplete
      options={suppliers}
      value={selected}
      disabled={disabled}
      getOptionLabel={(option) => option.supplierName}
      isOptionEqualToValue={(option, current) =>
        option.supplierId === current.supplierId
      }
      onChange={(_, option) => onChange(option?.supplierId ?? null)}
      renderInput={(params) => (
        <TextField {...params} label="Leverantör" size="small" />
      )}
    />
  );
};

export default SupplierPicker;
